import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Button,
  MenuItem,
  withStyles,
  Paper,
  MenuList,
  Popper,
  ClickAwayListener,
  Grow,
  Grid,
} from '@material-ui/core'
import { Sort as SortIcon } from '@material-ui/icons'
import { toggleSortMenu, changeSort } from 'actions/signupForm'
import styles from './styles'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({ open: state.signupForm.sortMenuOpen }),
  dispatch => bindActionCreators({ toggleSortMenu, changeSort }, dispatch)
)(
  withStyles(styles)(
    class Sort extends Component {
      handleClose = sort => event => {
        if (this.anchorEl.contains(event.target)) {
          return
        }
        this.props.toggleSortMenu()
        if (sort) this.props.changeSort(sort)
      }

      render() {
        const { classes, open, toggleSortMenu } = this.props

        return (
          <Paper className={classes.sort}>
            <Grid container justify="space-between">
              <Grid item>
                  {/* <ToggleViewButton icon /> */}
              </Grid>
              <Grid item>
                <Button
                  buttonRef={node => {
                    this.anchorEl = node
                  }}
                  aria-owns={open ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={toggleSortMenu}
                  style={{ color: '#fff' }}
                >
                  <SortIcon className={classes.leftIcon} />
                  {language.signupform.menuSort.sort}
                </Button>
              </Grid>
            </Grid>
            <Popper
              open={open}
              anchorEl={this.anchorEl}
              transition
              disablePortal
              style={{ zIndex: 1 }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  id="menu-list-grow"
                  style={{
                    transformOrigin:
                      placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={this.handleClose()}>
                      <MenuList>
                        <MenuItem onClick={this.handleClose('az')}>
                          {language.signupform.menuSort.nameAZ}
                        </MenuItem>
                        <MenuItem onClick={this.handleClose('za')}>
                          {language.signupform.menuSort.nameZA}
                        </MenuItem>
                        <MenuItem onClick={this.handleClose('oldestFirst')}>
                          {language.signupform.menuSort.oldFirst}
                        </MenuItem>
                        <MenuItem onClick={this.handleClose('newestFirst')}>
                          {language.signupform.menuSort.newFirst}
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Paper>
        )
      }
    }
  )
)
